import { render, staticRenderFns } from "./talk-detail.vue?vue&type=template&id=50d64f23&scoped=true"
import script from "./talk-detail.vue?vue&type=script&lang=js"
export * from "./talk-detail.vue?vue&type=script&lang=js"
import style0 from "./talk-detail.vue?vue&type=style&index=0&id=50d64f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d64f23",
  null
  
)

export default component.exports